import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobe, FaMobile, FaTabletAlt, FaArrowRight, FaCheck } from 'react-icons/fa';
import { SiPwa } from 'react-icons/si';
import Reveal from '../Reveal';
import {
  ServicesSection,
  Container,
  SectionHeader,
  SectionTag,
  SectionTitle,
  SectionSubtitle,
  ServicesGrid,
  ServiceCard,
  CardTop,
  ServiceNumber,
  IconBox,
  CardBody,
  CardTitle,
  CardDesc,
  FeatureList,
  FeatureItem,
  CardFooter,
  CardLink,
} from './Services.styles';

const servicesMeta = [
  { key: 'web', icon: <FaGlobe />, features: ['React & Next.js', 'Responsive design', 'SEO', 'TypeScript'], color: '#c88b3a', accent: 'linear-gradient(135deg, #9a6328, #d7a352)' },
  { key: 'pwa', icon: <SiPwa />, features: ['Offline mode', 'Push notifications', 'Installable', 'Service Workers'], color: '#a88a5a', accent: 'linear-gradient(135deg, #7b6545, #c6a571)' },
  { key: 'expo', icon: <FaMobile />, features: ['iOS & Android', 'Expo SDK', 'Native APIs', 'OTA updates'], color: '#e6b866', accent: 'linear-gradient(135deg, #b67a2a, #e6b866)' },
  { key: 'webapp', icon: <FaTabletAlt />, features: ['React + TypeScript', 'REST / GraphQL', 'Auth', 'Admin panel'], color: '#8fa1b5', accent: 'linear-gradient(135deg, #5d7389, #9fb0c1)' },
];

const Services: React.FC = () => {
  const { t } = useTranslation();

  return (
    <ServicesSection>
      <Container>
        <Reveal>
          <SectionHeader>
            <div>
              <SectionTag>{t('services.tag')}</SectionTag>
              <SectionTitle>
                {t('services.title')} <span>{t('services.titleGradient')}</span>
              </SectionTitle>
            </div>
            <SectionSubtitle>{t('services.subtitle')}</SectionSubtitle>
          </SectionHeader>
        </Reveal>

        <Reveal delay={90}>
          <ServicesGrid>
            {servicesMeta.map((s, index) => {
              const featured = index === 0 || index === servicesMeta.length - 1;

              return (
                <ServiceCard key={s.key} $accentColor={s.accent} $featured={featured}>
                  <CardTop>
                    <ServiceNumber>{String(index + 1).padStart(2, '0')}</ServiceNumber>
                    <IconBox $color={s.color}>{s.icon}</IconBox>
                  </CardTop>

                  <CardBody $featured={featured}>
                    <div>
                      <CardTitle>{t(`services.${s.key}.title`)}</CardTitle>
                      <CardDesc>{t(`services.${s.key}.desc`)}</CardDesc>
                    </div>

                    <FeatureList $featured={featured}>
                      {s.features.map((f) => (
                        <FeatureItem key={f}>
                          <FaCheck size={10} />
                          {f}
                        </FeatureItem>
                      ))}
                    </FeatureList>
                  </CardBody>

                  <CardFooter>
                    <CardLink to="/uslugi" $color={s.color}>
                      {t('services.learnMore')} <FaArrowRight size={11} />
                    </CardLink>
                  </CardFooter>
                </ServiceCard>
              );
            })}
          </ServicesGrid>
        </Reveal>
      </Container>
    </ServicesSection>
  );
};

export default Services;
